export default "__VITE_ASSET__Bm5LqVBa__"